export default `attribute float aSeed;
attribute float aBright; 
attribute float aT; 
attribute float aIsBlock; 

uniform float uTime;
uniform float uSize;
uniform float uScale;
uniform float uPixelRatio;
uniform float uReveal;
uniform float uGlyphCount;
uniform float uFlowSpeed; 

varying float vGlyph;
varying float vBright;
varying float vAlpha;

float band(float t, float head, float width) {
  float d = t - head;
  d = d - floor(d + 0.5); 
  return exp(-d * d / width);
}

void main() {
  vec3 pos = position;
  pos.y += sin(uTime * 0.8 + aSeed * 30.0) * 0.04; 

  vec4 mv = modelViewMatrix * vec4(pos, 1.0);
  gl_Position = projectionMatrix * mv;

  
  float head = fract(uTime * uFlowSpeed);
  float pulse = band(aT, head, 0.012);
  pulse = max(pulse, band(aT, fract(uTime * uFlowSpeed + 0.5), 0.025) * 0.5);

  float baseB = aBright * (0.45 + 0.2 * aIsBlock); 
  vBright = clamp(baseB + pulse * 0.9, 0.0, 1.0);
  vGlyph = floor(vBright * (uGlyphCount - 1.0) + 0.5);
  vAlpha = uReveal * clamp(0.3 + baseB * 0.45 + pulse * 0.85, 0.0, 1.0);

  gl_PointSize = uSize * uPixelRatio * (uScale / max(-mv.z, 0.1)) * (1.0 + pulse * 0.9);
}`